export default __webpack_public_path__ + "static/media/simbolo_open_finance.8954bc1f.png";